import { render, staticRenderFns } from "./DimensionSelect.vue?vue&type=template&id=d31bac9e"
import script from "./DimensionSelect.vue?vue&type=script&lang=ts"
export * from "./DimensionSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports